import * as Yup from "yup";
import { Receivable } from "../../../services/eligibilityService/EligibilityService.type";
import { ReceivablesDetailState } from "./ReceivablesDetailsFold";

export const receivablesDetailsFoldConstants = {
  labels: {
    gstin: "GSTIN of the customer",
    receivableAmountForNextFourMonths:
      "Total receivables for the next 4 months(in Rs)"
  },
  placeholders: {
    gstin: "Select"
  },
  buttons: {
    next: "Next"
  }
};

const errorMessages = {
  required: "Required",
  invalidFormat: "Invalid Format",
  positiveNumber: "Must be positive"
};

export const receivablesDetailsFoldValidationSchema = Yup.object().shape<
  ReceivablesDetailState
>({
  receivablesDetails: Yup.array<Receivable>().of(
    Yup.object<Receivable>().shape<Receivable>({
      gstin: Yup.string()
        .required(errorMessages.required)
        .nullable(),
      receivableAmountForNextFourMonths: Yup.number()
        .required(errorMessages.required)
        .typeError(errorMessages.invalidFormat)
        .nullable()
        .min(0, errorMessages.positiveNumber),
      status: Yup.mixed().nullable(),
      tradeName: Yup.string().nullable()
    })
  )
});
